module.exports = __webpack_public_path__ + "img/1.929d2a5b.jpg";